import { render, staticRenderFns } from "./ListOrdersArchives.vue?vue&type=template&id=6302e953&scoped=true&"
import script from "./ListOrdersArchives.vue?vue&type=script&lang=js&"
export * from "./ListOrdersArchives.vue?vue&type=script&lang=js&"
import style0 from "./ListOrdersArchives.vue?vue&type=style&index=0&id=6302e953&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6302e953",
  null
  
)

export default component.exports